import uuid from 'uuid';

// TODO remove this file completely
export default uuid.v4;
